import React from 'react';
import classNames from 'classnames';
import type { TeamPackageLike } from '@/domains/team/teamPackage';
import {
  getTeamPackageBadgeVariant,
  getTeamPackageDisplayLabel,
} from '@/domains/team/teamPackage';
import { useOfficialStore } from '$/store/useOfficialStore';
import styles from './index.module.scss';

export interface TeamPackageBadgeProps {
  /** 指定团队套餐信息；仅用于团队列表等没有当前会员详情的历史场景。 */
  teamInfo?: TeamPackageLike | null;
  /** 标签外观：filled 用于团队信息区域，outline 用于团队资产空间卡片。 */
  appearance?: 'filled' | 'outline';
  /** 外层自定义类名。 */
  className?: string;
}

/** 展示团队会员等级标签，集中维护后端会员文案和等级颜色映射。 */
function TeamPackageBadge({
  teamInfo,
  appearance = 'filled',
  className,
}: TeamPackageBadgeProps) {
  const currentSubscribe = useOfficialStore((state) => state.userInfo.subscribe);
  const resolvedLevel = teamInfo?.level ?? currentSubscribe?.level;
  const packageBadgeVariant = getTeamPackageBadgeVariant(resolvedLevel);
  const packageBadgeVariantClassName = {
    free: styles.free,
    standard: styles.standard,
    premium: styles.premium,
    flagship: styles.flagship,
    platinum: styles.platinum,
    blackGold: styles.blackGold,
  }[packageBadgeVariant];

  return (
    <span
      className={classNames(
        styles.badge,
        styles[appearance],
        packageBadgeVariantClassName,
        className,
      )}
    >
      {getTeamPackageDisplayLabel(resolvedLevel, currentSubscribe?.membershipInfos)}
    </span>
  );
}

export default TeamPackageBadge;
